import stripHTML from 'src/filters/stripHtml';

export default (str = '', limit = 40, end = '...') => {
  return stripHTML(
    str && str.length > limit ? str.slice(0, limit - end.length) + end : str,
  );
}